import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69cee97fc3f8480013a5a84c/stylesyndicate/node_modules/next/dist/client/app-dir/link.js");
